export const GenderSplitStorageKey = 'gender-split';
